import { useSyncExternalStore } from 'react';

/**
 * Telefon dalında mıyız? Yerlice `hooks/useDarEkran.ts` ile AYNI kural: eşik 767 px (Layout'un
 * `mobile` kırılımı ve CSS'teki `max-width: 767px` ile aynı sayı), karar görünüm genişliğinden.
 *
 * `matchMedia` yoksa ya da eşleşmiyorsa `false` (masaüstü). `vitest.setup.ts` `matches: false`
 * döndürür: testler masaüstü kipinde koşar; kart kipini sınayan test kipi açıkça verir.
 */
export function useDarEkran(esik = 767): boolean {
  return useSyncExternalStore(
    (bildir) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
      const mq = window.matchMedia(`(max-width: ${esik}px)`);
      mq.addEventListener('change', bildir);
      return () => mq.removeEventListener('change', bildir);
    },
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(`(max-width: ${esik}px)`).matches,
    () => false,
  );
}
